import type { MetaFunction } from '@remix-run/node';
import { MarginRail } from '~/components/way-in/margin-rail';
import { WayInLink } from '~/components/way-in/way-in-button';
import { ActionAside, WayInShell } from '~/components/way-in/way-in-shell';
import { FineNote, Headline, Lede } from '~/components/way-in/way-in-type';

export const meta: MetaFunction = () => [{ title: 'Pass this on | Science Exchange' }];

// The buyer-invite door names a contact but has no handoff when that contact is
// the wrong person — a recorded design gap, not yet designed. The link exists on
// step 1 because the case is real even when the named person is not the one to run it.

export default function PassThisOn() {
  return (
    <WayInShell
      pill="top-left"
      rail={
        <MarginRail
          mark={{ kind: 'numeral', value: '01' }}
          label="Who you are"
          progress={25}
          position="Step 1 of 4"
        />
      }
      actions={
        <>
          <WayInLink to="/onboard">Back</WayInLink>
          <ActionAside>Nothing has been sent</ActionAside>
        </>
      }
    >
      <Headline className="max-w-[18ch]">Not yours to run?</Headline>
      <Lede>
        The invitation stays open. Handing it to a colleague keeps the buyer&rsquo;s request intact
        and gives them the same two-minute door.
      </Lede>
      <FineNote className="mt-7 max-w-[60ch]">
        This handoff is a known gap in the buyer-invite door and is not designed yet.
      </FineNote>
    </WayInShell>
  );
}
